<h2 mat-dialog-title>Multi-page PDF</h2>
<mat-dialog-content>
	<p class="mp-file">
		<mat-icon>picture_as_pdf</mat-icon>
		<span>{{ data.fileName }}</span>
	</p>
	<p class="mp-question">
		This PDF has <strong>{{ data.pageCount }}</strong> pages. How should it be read?
	</p>

	<div class="mp-choices">
		<button mat-stroked-button class="mp-choice" (click)="choose('single')">
			<mat-icon>description</mat-icon>
			<span class="mp-choice-title">One credit memo</span>
			<span class="mp-choice-sub">All pages are a single document</span>
		</button>
		<button mat-stroked-button class="mp-choice" (click)="choose('split')">
			<mat-icon>content_copy</mat-icon>
			<span class="mp-choice-title">Split — one per page</span>
			<span class="mp-choice-sub">Each page is a separate credit memo</span>
		</button>
	</div>

	<mat-checkbox [(ngModel)]="remember" class="mp-remember">
		Remember my choice for next time
	</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
